import React from 'react';
import { Modal } from 'hyperdb-utils';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PictureForm from './PictureForm';

class PicturesTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangePicture = this.handleChangePicture.bind(this);
    this.handleUploadPicture = this.handleUploadPicture.bind(this);
    this.handleDeletePicture = this.handleDeletePicture.bind(this);
    this.state = {};
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadSuccess) {
      this.savePicturesOrder(nextProps);
      this.handleToggleModalForm(false);
    }
    if (nextProps.deletePictureSuccess) {
      const deletedPicture = nextProps.pictures[this.state.indexDeletePicture];
      const pictures = nextProps.pictures.filter(p => p.id !== deletedPicture.id);
      this.props.onDeletePictureSuccess(pictures);
      this.handleToggleModalDelete(-1);
    }
  }
  render() {
    const props = this.props;
    return (
      <fieldset>
        <div className="box-header">
          <span>
            <b>Pictures for property</b>
            &nbsp;
            {
              props.pictures.length < 20
                ? <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModalForm.bind(this, true, -1) }>Add</button>
                : null
            }
          </span>
        </div>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>Picture</th>
                <th>Info</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                props.pictures.map((picture, i) => {
                  const imgURL = this.props.pictureUrl(picture, 'original');
                  const thumbURL = this.props.pictureUrl(picture, 'thumbnail');
                  return (
                    <tr key={ i }>
                      <td>
                        {
                          imgURL
                            ? <a href={ imgURL } target="_blank">
                                <img src={ thumbURL } alt="thumbnail" style={{maxWidth: '90px', maxHeight: '60px'}}/>
                              </a>
                            : <img src={ thumbURL } alt="thumbnail" style={{maxWidth: '90px', maxHeight: '60px'}}/>
                        }
                      </td>
                      <td>
                        Filename: { picture.filename ? (picture.filename.$i18n || {})[props.defaultLanguage] : '' }
                        <br/>
                        Title: { picture.title ? (picture.title.$i18n || {})[props.defaultLanguage] : '' }
                        <br/>
                        Description: { picture.description ? (picture.description.$i18n || {})[props.defaultLanguage] : '' }
                        <br/>
                        {
                          !picture.original || !picture.original.value || !picture.thumbnail || !picture.thumbnail.value
                            ? <span className="text-danger"><i className="fas fa-warning"/> The picture wasn't uploaded correctly. Please try again.</span>
                            : null
                        }
                      </td>
                      <td>
                        Published: { picture.published ? <i className="fa fa-check text-success" /> : <i className="fa fa-times text-danger" /> }
                        <br/>
                        Shared: { picture.shared ? <i className="fa fa-check text-success" /> : <i className="fa fa-times text-danger" /> }
                      </td>
                      <td>
                        <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                          <MenuItem onClick={ this.handleToggleModalForm.bind(this, true, i) }>Edit</MenuItem>
                          {
                            i !== 0
                              ? <MenuItem onClick={ this.handleMovePicture.bind(this, 'up', i) }>Move Up</MenuItem>
                              : null
                          }
                          {
                            i !== props.pictures.length - 1
                              ? <MenuItem onClick={ this.handleMovePicture.bind(this, 'down', i) }>Move Down</MenuItem>
                              : null
                          }
                          <MenuItem onClick={ this.handleToggleModalDelete.bind(this, i) }>Delete</MenuItem>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showModalFormPicture
            ? <Modal title="" onClose={ this.handleToggleModalForm.bind(this, false) } onAccept={ this.handleUploadPicture } loading={ props.uploadingPicture }>
                <PictureForm
                  { ...props }
                  object={ props.objectData }
                  picture={ this.state.editedPicture }
                  pictureUrl={ this.props.pictureUrl }
                  backendEntryPoint="/properties"
                  onChange={ this.handleChangePicture }
                  picturesList={ props.pictures }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalDeletePicture
            ? <Modal title="Delete picture" onClose={ this.handleToggleModalDelete.bind(this, -1) } onAccept={ this.handleDeletePicture } loading={ props.deletingPicture }>
                Delete this picture ?
                <br/>
                { props.deletingPicture ? 'DELETING...' : '' }
              </Modal>
            : null
        }
      </fieldset>
    );
  }

  handleToggleModalForm(bool, indexEditedPicture = -1) {
    const editedPicture = bool && indexEditedPicture !== -1
      ? { ...this.props.pictures[indexEditedPicture], _new_position: indexEditedPicture }
      : { shared: true, _new_position: (this.props.pictures || []).length };
    this.setState({ showModalFormPicture: bool, indexEditedPicture, editedPicture });
  }
  handleChangePicture(picture) {
    this.setState({ editedPicture: picture });
  }
  handleUploadPicture(picture) {
    const editedPicture = this.state.editedPicture;
    if (!editedPicture.original && !editedPicture._new) return null;
    const property = this.props.objectData;
    this.props.onSavePicture(editedPicture);
  }
  savePicturesOrder(nextProps) {
    const { editedPicture, indexEditedPicture } = this.state;
    const pictures = (nextProps.objectData.pictures || []).slice();
    if (indexEditedPicture !== -1) {
      pictures.splice(indexEditedPicture, 1);
    }
    pictures.splice(editedPicture._new_position || 0, 0, nextProps.savedPicture || editedPicture);
    delete editedPicture._new_position;
    this.props.onChange('pictures', { value: pictures });
    this.props.onSavePicturesOrder(pictures);
  }
  handleMovePicture(direction, index) {
    const pictures = this.props.pictures.slice();
    const picture = pictures[index];
    let doMove = false;
    let newIndex;
    if (direction === 'up') {
      if (index !== 0) {
        doMove = true;
        newIndex = index - 1;
      }
    } else {
      if (index !== pictures.length - 1) {
        doMove = true;
        newIndex = index + 1;
      }
    }
    if (doMove) {
      pictures.splice(index, 1);
      pictures.splice(newIndex, 0, picture);
      this.props.onChange('pictures', { value: pictures });
    }
  }

  handleToggleModalDelete(indexDeletePicture = -1) {
    const showModalDeletePicture = indexDeletePicture !== -1;
    this.setState({ showModalDeletePicture, indexDeletePicture });
  }
  handleDeletePicture() {
    const picture = this.props.pictures[this.state.indexDeletePicture];
    this.props.onDeletePicture(picture.id);
  }
}

export default PicturesTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/PicturesTab.jsx